<mat-card class="cardWithShadow">
  <mat-card-content class="p-24">

    <div style="text-align: center;" *ngIf="dataSource.data.length == 0">
      <h3>Sin Facturas</h3>
    </div>

        <div class="table-responsive" [ngClass]="{ 'oculto': dataSource.data.length == 0 }">
          <table
            mat-table
            [dataSource]="dataSource"
            class="w-100"
            matSort
            matSortDirection="asc"
            (matSortChange)="sortChange($event)"
          >
            <!-- Position Column -->
            <ng-container matColumnDef="folio">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="th-title"
              >
                Folio
              </th>
              <td mat-cell *matCellDef="let element"
              (click)="openDetalleFactura(element)"
              style="text-decoration: underline; color: blue; cursor: pointer">
                <h6>
                  {{ element.folio }}
                </h6>
              </td>
            </ng-container>
            <ng-container matColumnDef="iconOperation">
              <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              
            </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="openDialogOperation(element)"
              >
                <i-tabler name="file-plus" class="icon-20 operation_mobile"></i-tabler>
              </td>
            </ng-container>
        
            <!-- Name Column -->
            <ng-container matColumnDef="clientRut">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="th-title"
              >
                Rut
              </th>
              <td mat-cell *matCellDef="let element" class="mat-body-1">
                <h6>
                  {{ element.clientRut }}
                </h6>
              </td>
            </ng-container>
            <ng-container matColumnDef="clientName">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="th-title"
              >
                Nombre
              </th>
              <td mat-cell *matCellDef="let element" class="mat-body-1">
                <h6>
                  {{ element.clientName }}
                </h6>
              </td>
            </ng-container>
            <ng-container matColumnDef="totalAmount">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="th-title"
              >
                Monto Total
              </th>
              <td mat-cell *matCellDef="let element" class="mat-body-1">
                <h6>$ {{ element.totalAmount | number : "3.0" }}</h6>
              </td>
            </ng-container>
        
            <ng-container matColumnDef="hasBuyOrder">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="th-title"
              >
                Orden de Compra
              </th>
              <td mat-cell *matCellDef="let element" class="mat-body-1">
                <i-tabler
                  *ngIf="element.hasBuyOrder"
                  name="circle-check-filled"
                  class="icon-20"
                  style="color: mediumspringgreen"
                ></i-tabler>
        
                <i-tabler
                  *ngIf="!element.hasBuyOrder"
                  name="circle-x-filled"
                  class="icon-20"
                  style="color: red"
                ></i-tabler>
              </td>
            </ng-container>
        
            <ng-container matColumnDef="numberInvoice">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="th-title"
              >
                Enumeracion de factura con Cliente
              </th>
              <td mat-cell *matCellDef="let element" class="mat-body-1">
                <h6>
                  <h6>{{ element.numberInvoice }}</h6>
                </h6>
              </td>
            </ng-container>
        
            <ng-container matColumnDef="fechaDocto">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="th-title"
              >
                Fecha Documento
              </th>
              <td mat-cell *matCellDef="let element" class="mat-body-1">
                <h6>{{ element.fechaDocto | date : "dd/MM/yyyy" }}</h6>
              </td>
            </ng-container>
        
            <ng-container matColumnDef="numberInvoiceInFactoring">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="th-title"
              >
                N° Facturas relacionadas con Factoring
              </th>
              <td mat-cell *matCellDef="let element" class="mat-body-1">
                <h6>{{ element.amountFact | number : "3.0" }}</h6>
              </td>
            </ng-container>
            <ng-container matColumnDef="isCedible">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="th-title"
              >
                Cedible
              </th>
              <td mat-cell *matCellDef="let element" class="mat-body-1">
                <i-tabler
                  *ngIf="element.isCedible"
                  name="circle-check-filled"
                  class="icon-20"
                  style="color: mediumspringgreen"
                ></i-tabler>
        
                <i-tabler
                  *ngIf="!element.isCedible"
                  name="circle-x-filled"
                  class="icon-20"
                  style="color: red"
                ></i-tabler>
              </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              [cdkContextMenuTriggerFor]="menu"
              *matRowDef="let row; columns: displayedColumns"
              class="cursor_table"
            >
              <ng-template #menu>
                <div cdkMenu class="context_menu mat-elevation-z8">
                  <button
                    class="context-menu-item"
                    cdkMenuItem
                    mat-raised-button
                    style="background-color: #3f51b5; color: white"
                    (click)="openDialog(row.invoiceId)"
                  >
                    Orden de Compra
                  </button>
        
                  <button
                    class="context-menu-item"
                    cdkMenuItem
                    mat-raised-button
                    style="background-color: #198754; color: white; margin-top: 3px"
                    (click)="openDialogOperation(row)"
                  >
                    Crear Operacion
                  </button>
                  <button class="context-menu-item"
                  cdkMenuItem mat-raised-button
                  (click)="viewDebtorRelation(row.clientRut)">
                    Ver relación con cliente
                  </button>
                </div>
              </ng-template>
            </tr>
        
            <!-- Row shown when there is no matching data. -->
            <!-- <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  No data matching the filter "{{ input.value }}"
                </td>
              </tr> -->
          </table>
          <mat-paginator [pageSizeOptions]="[5, 10, 20, 100]"></mat-paginator>
        </div>
  </mat-card-content>

</mat-card>